<div id="app" class="app h-100" :dir="dir" :theme="themeCompany" data-app>
    <router-view />
</div>
